"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.validatorHelp = exports.validators = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _validator = require("validator");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var validators = {
  email: _validator.isEmail,
  phone: _validator.isMobilePhone,
  alpha: _validator.isAlpha,
  alphaNum: _validator.isAlphanumeric,
  decimal: _validator.isDecimal
};
exports.validators = validators;
var validatorHelp = {
  email: 'Please enter a valid email address',
  phone: 'Please enter a valid phone number',
  alpha: 'Please enter only letters',
  alphaNum: 'Please enter only letters or numbers',
  decimal: 'Please enter a valid decimal number with no additional characters'
};
exports.validatorHelp = validatorHelp;

var Field = /*#__PURE__*/function (_React$Component) {
  _inherits(Field, _React$Component);

  var _super = _createSuper(Field);

  function Field() {
    var _this;

    _classCallCheck(this, Field);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      focused: false,
      validateOk: false
    };

    _this.onFocus = function () {
      return _this.setState({
        focused: true
      });
    };

    _this.onBlur = function () {
      return _this.setState({
        focused: false,
        validateOk: true
      });
    };

    _this.focusInput = function () {
      return _this.onFocus() && _this.input && _this.input.focus();
    };

    _this.setRef = function (r) {
      return _this.input = r;
    };

    return _this;
  }

  _createClass(Field, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          inline = _this$props.inline,
          children = _this$props.children,
          label = _this$props.label,
          help = _this$props.help,
          error = _this$props.error,
          success = _this$props.success,
          noLabel = _this$props.noLabel,
          size = _this$props.size,
          disabled = _this$props.disabled,
          validateFor = _this$props.validateFor,
          value = _this$props.value,
          danger = this.props.danger || this.props.error,
          _this$state = this.state,
          focused = _this$state.focused,
          validateOk = _this$state.validateOk,
          labelComp = /*#__PURE__*/_react.default.createElement("label", {
        className: (0, _classnames3.default)('label', _defineProperty({}, "is-".concat(size), !inline && size))
      }, label);

      if (validateOk && !error) {
        if (value && typeof validators[validateFor] === 'function' && !validators[validateFor](value)) {
          error = validatorHelp[validateFor];
        }
      }

      var bodyComp = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, typeof children === 'function' ? children({
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        focusInput: this.focusInput,
        setRef: this.setRef,
        focused: focused,
        danger: danger || !!error,
        success: success,
        disabled: disabled,
        inline: inline,
        size: size
      }) : children, help && !error && /*#__PURE__*/_react.default.createElement("p", {
        className: (0, _classnames3.default)('help', {
          'is-danger': danger,
          'is-success': success
        })
      }, help), error && /*#__PURE__*/_react.default.createElement("p", {
        className: (0, _classnames3.default)('help', 'is-danger')
      }, error));

      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames3.default)('field', 'frikin-field', className, {
          'field-focused': focused,
          'is-horizontal': inline,
          'is-disabled': disabled,
          'is-danger': !!error
        }),
        onClick: this.focusInput
      }, label && !noLabel && (inline ? /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames3.default)('field-label', _defineProperty({
          'is-normal': !size
        }, "is-".concat(size), size))
      }, labelComp) : labelComp), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames3.default)({
          'field-body': inline
        })
      }, !inline ? /*#__PURE__*/_react.default.createElement("div", {
        className: "field"
      }, bodyComp) : bodyComp));
    }
  }]);

  return Field;
}(_react.default.Component);

exports.default = Field;
Field.propTypes = {
  className: _propTypes.default.string,
  inline: _propTypes.default.bool,
  children: _propTypes.default.any.isRequired,
  error: _propTypes.default.any,
  validate: _propTypes.default.func,
  validateFor: _propTypes.default.string,
  value: _propTypes.default.any
};